export const GET_IC = "GET_IC";
export const GET_IC_MODAL = "GET_IC_MODAL";
export const GET_SOCIOS_SOCIEDADES = "GET_SOCIOS_SOCIEDADES";
export const GET_SOCIOS_SOCIEDADES_MODAL = "GET_SOCIOS_SOCIEDADES_MODAL";
export const GET_ERROR  = "GET_ERROR";
export const GET_SCORE_PDF = "GET_SCORE_PDF";
export const GET_DETALLE_CONYUGE = "GET_DETALLE_CONYUGE";
export const GET_DETALLE_CONYUGE_MODAL = "GET_DETALLE_CONYUGE_MODAL";
export const GET_DETALLE_DIRECCIONES = "GET_DETALLE_DIRECCIONES";
export const GET_DETALLE_DIRECCIONES_MODAL = "GET_DETALLE_DIRECCIONES_MODAL";
export const GET_DETALLE_PROPIEDADES_BIENES = "GET_DETALLE_PROPIEDADES_BIENES";
export const GET_DETALLE_PROPIEDADES_BIENES_MODAL = "GET_DETALLEGET_DETALLE_PROPIEDADES_MODAL";
export const GET_DETALLE_BOLETIN = "GET_DETALLE_BOLETIN";
export const GET_DETALLE_BOLETIN_MODAL = "GET_DETALLE_BOLETIN_MODAL";
export const GET_DETALLE_VEHICULO = "GET_DETALLE_VEHICULO";
export const GET_DETALLE_VEHICULO_MODAL = "GET_DETALLE_VEHICULO_MODAL"
export const ASIGNO_DIGITO_VERIFICADOR = "ASIGNO_DIGITO_VERIFICADOR";
export const ASIGNO_RUT_CONSULTA = "ASIGNO_RUT_CONSULTA";
export const GET_VERIFICACION = "GET_VERIFICACION";
export const GET_DOCUMENT_PCH = "GET_DOCUMENT_PCH";
export const GET_DETALLE_EXTRACTO = "GET_DETALLE_EXTRACTO";
export const ASIGNO_NSERIES_EMPRESA = "ASIGNO_NSERIES_EMPRESA";
export const ASIGNO_ESTADO_CARGA = "ASIGNO_ESTADO_CARGA";//estado de loading carg
export const GET_ESTRUCTURA_FINANCIERA = "GET_ESTRUCTURA_FINANCIERA";
export const GET_ESTRUCTURA_FINANCIERA_MODAL = "GET_ESTRUCTURA_FINANCIERA_MODAL";
export const GetOnp = "GetOnp";
export const GetBanco = "GetBanco";
export const AuthLogin=  "AuthLogin";
export const loading_Auth= "loading_Auth"
export const AuthLogout= "AuthLogout";
export const SET_CURRENT_USER= "SET_CURRENT_USER";
export const GetPerfil="GetPerfil";
export const GetPermisos="GetPermisos";

export const GetContraInfoCom="GetContraInfoCom";
export const GetContraVerifOnp="GetContraVerifOnp";

export const GetSoporte="GetSoporte";
export const GetUsuarios="GetUsuarios";
export const GetResumen="GetResumen";
export const GetDetalle="GetDetalle";
export const code_error = "code_error";
export const GetResumenGrafico="GetResumenGrafico";
export const GetSKL="GetSKL";

export const GetProducts = "GetProducts";
export const LogoutAll = "LogoutAll";
export const SklLogin = "SklLogin";
export const GetUrlBase = "GetUrlBase";
export const get_TipoContrato = "get_TipoContrato";
export const GetConsumoSaldno = "GetConsumoSaldno";
export const STATE_OK_LOADING_IC = "STATE_OK_LOADING_IC";

export const types = {
    AuthChecking: "AutChecking",
    AuthCheckingFinish: "AuthCheckingFinish",
    AuthLogin: "AuthLogin",
    AuthLogout: "AuthLogout",
    SklLogin: 'SklLogin',
    AutoRedirect: 'AutoRedirect'
}


